import React, { useEffect } from "react";
import { Header } from "../commons/components";
import { Content } from "./components";

function Login() {
  useEffect(() => {
    document.title = `404 Not found - Nadi Admin`;
  }, []);

  return (
    <div className="App">
      <Header />

      <div className="container flex items-center justify-center mt-20 py-10">
        <Content />
      </div>
    </div>
  );
}

export default Login;
